import React from 'react';

import Section from 'react-scale/components/elements/section';
import { Grid, GridItem } from 'react-scale/components/website/big/main/Grid';
import VideoHls from 'react-scale/components/website/customers/case/VideoHls';
import ReactPlayerWrapper from 'react-scale/components/website/ReactPlayerNoContainer';

import { mq } from 'react-scale/components/website/big/Themes';

const renderVideo = (videoProvider, canAutoplay, videoTitle, videoURL, poster) => {
  switch (videoProvider) {
    case 'youtube':
      return (
        <ReactPlayerWrapper
          canAutoplay={canAutoplay}
          videoSrc={videoURL}
          poster={poster}
          alt={videoTitle}
        />
      );
    default:
      return (
        <VideoHls
          src={videoURL}
          poster={poster}
          alt={videoTitle}
          muted
          playsinline
          controls={false}
          autoPlay={canAutoplay}
          loop
          fullHeight
          fullWidth
          blur
          playStopOnViewportChange
        />
      );
  }
};

const TitleVideo = ({
  videoProvider,
  canAutoplay,
  videoTitle,
  videoURL,
  poster,
  lineColor,
  titleColumns,
  backgroundHeight
}) => (
  <Section container={false}>
    <div className="title-video">
      <div className="container">
        <Grid margin={{ xl: 0, lg: 0, md: 0, xs: 0 }} rowGap={{ xl: 0, lg: 0, md: 0, xs: 0 }}>
          <GridItem xl={titleColumns.xl} lg={titleColumns.lg}>
            <div className="title">
              <h1 className="text-2xl text-white">{videoTitle}</h1>
            </div>
          </GridItem>
          <GridItem xl="1 / 6" lg="1 / 6">
            <hr className="color-divider" />
          </GridItem>
          <GridItem xl="1 / 13" lg="1 / 13">
            <div className="video-wrapper">
              {renderVideo(videoProvider, canAutoplay, videoTitle, videoURL, poster)}
            </div>
          </GridItem>
        </Grid>
      </div>
      <style jsx>{`
        .title-video {
          position: relative;
          z-index: 10;
          padding: 0 0 calc(2rem * 2);
        }
        @media (min-width: ${mq.lg}) {
          .title-video {
            padding: 0;
          }
        }

        .title-video:before,
        .title:before {
          content: '';
          background: #000000;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: -1;
        }
        @media (min-width: ${mq.lg}) {
          .title-video:before,
          .title:before {
            height: calc(2rem * ${backgroundHeight});
            right: 50%;
            bottom: initial;
          }
        }
        .title {
          text-align: center;
          background: #000000;
          padding: calc(2rem * 2) 0 0;
          position: relative;
        }
        @media (min-width: ${mq.lg}) {
          .title {
            text-align: left;
            padding: calc(2rem * 3) 0 0;
          }
        }
        .title:before {
          right: 0;
        }
        .color-divider {
          background: ${lineColor};
          height: calc(2rem / 2);
          margin: calc(2rem * 1.5) 0 calc(2rem * 2);
          position: relative;
          border: 0;
          z-index: 10;
        }
      `}</style>
    </div>
  </Section>
);

TitleVideo.defaultProps = {
  titleVariant: 'h1XL', // custom variant for the title size
  titleColumns: {
    // quantity of columns the title spans
    xl: '1 / 11',
    lg: '1 / 12'
  },
  backgroundHeight: '22' // for desktopHeight
};

export default TitleVideo;
